// @module SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItems
define("SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItemsPDP.View", [
  "suitedb_sdbservicehardwareitems_sdbservicehardwareitemspdp.tpl",
  "SuiteDB.SDBServiceHardwareItems.SDBServiceHardwareItems.Model",
  "Backbone",
], function (
  suitedb_sdbservicehardwareitems_sdbservicehardwareitemspdp_tpl,
  SDBServiceHardwareItemsModel,
  Backbone
) {
  "use strict";

  return Backbone.View.extend({
    template: suitedb_sdbservicehardwareitems_sdbservicehardwareitemspdp_tpl,

    initialize: function initialize(options) {
      var self = this;
      //attributes
      this.options = options;
      this.model = SDBServiceHardwareItemsModel.getInstance();
      this.model.PDPView = this;
      this.serviceItems = options.serviceItems;
      this.hardwareItems = options.hardwareItems;
      this.services = [];
      this.item = JSON.parse(self.model.get("PDPItemInfo") || "null");

      this.render = _.wrap(this.render, function (fn) {
        if (this.model.PDPView && this.model.PDPView.cid !== this.cid) return;
        fn.apply(this, _.toArray(arguments).slice(1));
        setTimeout(function () {
          //disable button until at least one suggestion is selected
          var addSuggestionsButton = document.querySelector(
            ".add-recommendations-to-cart"
          );
          if (addSuggestionsButton) addSuggestionsButton.disabled = true;
        }, 0);
      });

      this.getServiceSelection = function (e) {
        var serviceCheck = $(e.target)
          .parents(".service-container")[0]
          .querySelector('input[type="checkbox"]');
        if (!serviceCheck) return;
        var serviceId = serviceCheck.getAttribute("data-value");
        if (!serviceId && !hardwareId) return;

        var input =
          $(e.target)
            .parents(".service-container")[0]
            .querySelector('input[type="number"]') ||
          $(e.target)
            .parents(".hardware-container")[0]
            .querySelector('input[type="number"]');
        if (!input) return;
        var quantity = Number(input.value);
        if (!quantity || quantity < 1) return;

        return {
          item: [self.item.internalid],
          id: serviceId,
          quantity: quantity,
        };
      };
      this.getHardwareSelection = function (e) {
        var hardwareCheck = $(e.target)
          .parents(".hardware-container")[0]
          .querySelector('input[type="checkbox"]');
        if (!hardwareCheck) return;
        var hardwareId = hardwareCheck.getAttribute("data-value");
        if (!hardwareId) return;

        var input = $(e.target)
          .parents(".hardware-container")[0]
          .querySelector('input[type="number"]');
        if (!input) return;
        var quantity = Number(input.value);
        if (!quantity || quantity < 1) return;

        return {
          item: [self.item.internalid],
          id: hardwareId,
          quantity: quantity,
        };
      };
    },

    events: {
      "click .service-quantity-button": "changeQuantity",
      "click .hardware-quantity-button": "changeHardwareQuantity",
      "click .checkbox-service-selection": "selectService",
      "click .checkbox-hardware-selection": "selectHardware",
      "click .add-recommendations-to-cart": "addSuggestions",
      "input .quantity-input-hardware": "updateHardwareQuantity",
    },

    bindings: {},

    childViews: {},
    updateHardwareQuantity: function updateHardwareQuantity(e) {
      var input = $(e.target)
        .parents(".hardware-container")[0]
        .querySelector('input[type="number"]');
      if (!input) return;
      var numberValue = Number(input.value);
      if (isNaN(numberValue)) return;
      if (input.value < 1) input.value = 1;

      var selection = this.getHardwareSelection(e);
      if (!selection) return;

      var selectedIndex = _.findIndex(
        this.model.selectedHardware,
        function (value) {
          return value.id == selection.id;
        }
      );
      if (selectedIndex == -1) return;

      selection.quantity = Number(input.value);
      this.model.selectedHardware[selectedIndex].quantity = selection.quantity;
    },
    addSuggestions: function changeQuantity() {
      this.model.updateCart();
      this.render();
    },
    selectService: function selectService(e) {
      var selection = this.getServiceSelection(e);
      if (!selection) {
        e.preventDefault();
        return;
      }

      //disable button if no suggestions selected
      var checkedServices = $(e.target)
        .parents(".suggested-item-list")[0]
        .querySelectorAll(".checkbox-service-selection:checked");
      var addSuggestionsButton = document.querySelector(
        ".add-recommendations-to-cart"
      );
      if (addSuggestionsButton && checkedServices.length)
        addSuggestionsButton.disabled = false;
      else addSuggestionsButton.disabled = true;

      if (!e.target.checked) {
        this.model.removeSelection(selection);
        return;
      }
      this.model.addSelection(selection);
    },
    selectHardware: function selectHardware(e) {
      var selection = this.getHardwareSelection(e);
      if (!selection) {
        e.preventDefault();
        return;
      }
      if (!e.target.checked) {
        this.model.selectedHardware = _.reject(
          this.model.selectedHardware,
          function (value) {
            return value.id == selection.id;
          }
        );
      } else {
        this.model.selectedHardware.push(selection);
      }
      var addSuggestionsButton = document.querySelector(
        ".add-recommendations-to-cart"
      );
      if (addSuggestionsButton && this.model.selectedHardware.length)
        addSuggestionsButton.disabled = false;
      else addSuggestionsButton.disabled = true;
    },
    changeQuantity: function changeQuantity(e) {
      var input = $(e.target)
        .parents(".service-container")[0]
        .querySelector('input[type="number"]');
      if (!input) return;
      var numberValue = Number(input.value);
      if (isNaN(numberValue)) return;
      if (e.target.innerHTML == "+") input.value++;
      else if (e.target.innerHTML == "-") input.value--;

      if (input.value < 1) input.value = 1;

      var selection = this.getServiceSelection(e);
      if (!selection) return;

      var selectedIndex = _.findIndex(
        this.model.selectedServices,
        function (value) {
          return value.id == selection.id;
        }
      );
      if (selectedIndex == -1) return;

      selection.quantity = Number(input.value);
      this.model.addSelection(selection);
    },
    changeHardwareQuantity: function changeHardwareQuantity(e) {
      var input = $(e.target)
        .parents(".hardware-container")[0]
        .querySelector('input[type="number"]');
      if (!input) return;
      var numberValue = Number(input.value);
      if (isNaN(numberValue)) return;
      if (e.target.innerHTML == "+") input.value++;
      else if (e.target.innerHTML == "-") input.value--;

      if (input.value < 1) input.value = 1;

      var selection = this.getHardwareSelection(e);
      if (!selection) return;

      var selectedIndex = _.findIndex(
        this.model.selectedHardware,
        function (value) {
          return value.id == selection.id;
        }
      );
      if (selectedIndex == -1) return;

      selection.quantity = Number(input.value);
      this.model.selectedHardware[selectedIndex].quantity = selection.quantity;
    },

    getContext: function getContext() {
      var suggestions = [];
      var model = this.model;
      if (this.item) suggestions = model.getRecommendations([this.item]);

      //put recommendations based on a service under the item the service is recommended from
      var serviceRecommendations = {};
      _.each(model.get("items"), function (item) {
        if (!model.serviceItems[item.internalid]) return;
        var itemSuggestions = model.getRecommendations([item]);
        if (!itemSuggestions.length) return;
        serviceRecommendations[item.internalid] = itemSuggestions[0];
      });
      _.each(suggestions, function (recommendation) {
        var servicesToRemove = [];
        _.each(recommendation.services, function (service) {
          if (serviceRecommendations[service.id])
            servicesToRemove.push(service);
        });
        recommendation.services = _.difference(
          recommendation.services,
          servicesToRemove
        );
        _.each(servicesToRemove, function (service) {
          recommendation.services = recommendation.services.concat(
            serviceRecommendations[service.id].services
          );
        });
      });
      suggestions = model.removeAddedRecommendations(suggestions);

      var applicable = false;
      if (suggestions.length) {
        suggestions = suggestions[0];
        applicable =
          !!(suggestions.services.length > 0) ||
          !!(suggestions.hardware.length > 0);
      }

      return {
        applicable: applicable,
        services: suggestions.services,
        hardware: suggestions.hardware,
        hasVehicleSelected:
          !!this.model.locations.getCookie("vehicleConfig").length,
      };
    },
  });
});
